// extracted by mini-css-extract-plugin
export default {"navigation":"src-modules-account-navigation-style__navigation_SNL8l","active":"src-modules-account-navigation-style__active_szZKJ"};